/**
 * Fuso operacional e conversão de filtro de período (RN-55).
 *
 * Regra do contrato (`03-endpoints-draft.md §0`): a resposta é sempre ISO-8601 em
 * UTC; o **filtro** chega como `YYYY-MM-DD` e é interpretado como dia civil de
 * America/São_Paulo. A conversão é do servidor — o cliente manda só a data.
 *
 * O deslocamento é fixo em `-03:00` porque o Brasil não observa horário de verão
 * desde 2019. Se voltar, é aqui que muda (para `Intl` com a zona), e em nenhum
 * outro lugar: por isso toda listagem chama estas duas funções em vez de montar
 * `new Date(...)` na mão.
 */

export const FUSO_OPERACIONAL = 'America/Sao_Paulo'
export const DESLOCAMENTO_OPERACIONAL = '-03:00'

/** Formato aceito nos filtros de período. */
export const PADRAO_DATA_ISO = /^\d{4}-\d{2}-\d{2}$/

/** `2026-08-10` → `2026-08-10T00:00:00.000-03:00`. */
export function inicioDoDiaOperacional(data: string): Date {
  return new Date(`${data}T00:00:00.000${DESLOCAMENTO_OPERACIONAL}`)
}

/** `2026-08-10` → `2026-08-10T23:59:59.999-03:00` (limite superior inclusivo). */
export function fimDoDiaOperacional(data: string): Date {
  return new Date(`${data}T23:59:59.999${DESLOCAMENTO_OPERACIONAL}`)
}

/** Dia civil de São Paulo de um instante — a chave de agrupamento dos agregados. */
export function diaOperacional(instante: Date): string {
  const deslocado = new Date(instante.getTime() - 3 * 60 * 60 * 1000)
  return deslocado.toISOString().slice(0, 10)
}

/**
 * Diferença em dias inteiros entre dois instantes. Usada pelo cálculo de
 * temperatura (RN-21) e pela finalização automática (RN-27), que raciocinam em
 * dias corridos e não em dias civis.
 */
export function diasEntre(inicio: Date, fim: Date): number {
  return Math.floor((fim.getTime() - inicio.getTime()) / 86_400_000)
}

/** Quantidade de dias no intervalo fechado `[de, ate]`, ambos `YYYY-MM-DD`. */
export function diasNoIntervalo(de: string, ate: string): number {
  const inicio = inicioDoDiaOperacional(de)
  const fim = inicioDoDiaOperacional(ate)
  return Math.floor((fim.getTime() - inicio.getTime()) / 86_400_000) + 1
}
